import React, { Component } from "react";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

class DiscountCode extends Component {
  state = {
    discountCodeValue: "",
    showDiscountCodeAdded: false
  };
  submitDiscountCode = () => {
    if (this.state.discountCodeValue) {
      this.props.setPromo_code(this.state.discountCodeValue);
    }
  };
  showDiscountCodeAdded = () => {
    if (this.state.discountCodeValue) {
      this.setState({ showDiscountCodeAdded: true });
    }
  };
  handleChange = event => {
    const discountCodeValue = event.target.value;
    this.setState({ discountCodeValue });
  };
  clearDiscountText = () => {
    this.setState({ showDiscountCodeAdded: false });
  };
  render() {
    const discountBox = {
      borderRadius: "2px",
      marginBottom: "4px",
      marginRight: "10px"
    };
    return (
      <div style={{ marginTop: "20px" }}>
        <h4
          style={{ marginBottom: "3px" }}
          className="doublestruck__font--primary"
        >
          {" "}
          Discount Code:
        </h4>
        <Form.Label label="discount" style={discountBox}>
          <Form.Control
            className="form__text-field"
            onChange={this.handleChange}
            onFocus={this.clearDiscountText}
            onBlur={this.submitDiscountCode}
          />
        </Form.Label>
        <Button
          onClick={this.showDiscountCodeAdded}
          className="add-promocode-btn"
        >
          Add Code
        </Button>
        <br />
        <i className="caption">
          Discount codes will be added once your order has been processed,
          please note that only valid codes will be applied.
        </i>
        {this.state.showDiscountCodeAdded && (
          <p className="promo-code__feedback">
            <i className="fa fa-check"></i>
            Thank you, your discount code has been added to your order and will
            be sent to be processed.
          </p>
        )}
      </div>
    );
  }
}

export default DiscountCode;
